import { render, staticRenderFns } from "./order-print.vue?vue&type=template&id=0422ec65&scoped=true"
import script from "./order-print.vue?vue&type=script&lang=js"
export * from "./order-print.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422ec65",
  null
  
)

export default component.exports